var eventTracking = {
    methods: {
      GAEventTrack: function(category, event, label, value = null){
        this.$ga.event(category, event, label, value)
      }
    }
}

export default eventTracking